import React from "react";
import { TextBlockShell } from './TextBlockShell';
import { merge } from './merge';
import type { BlockRenderProps } from './types';
import {
  applyTextLinkStyles,
  normalizeTextHtml,
  wrapTextInBlockHtml,
  wrapTextVariantHtml,
} from '../../domain/sanitize';
import { resolveLinkColor } from '../../domain/text-theme';
import type { TextBlock } from '../../domain/types';
import { isEmailBuilderRichTextEmpty } from '../../editing/richText/emailBuilderRichTextHtml';

function textBlockHtmlFromNormalized(
  block: TextBlock,
  textTheme: BlockRenderProps['textTheme'],
  normalized: string,
) {
  const wrapped = wrapTextVariantHtml(wrapTextInBlockHtml(normalized), block.variant);
  return {
    __html: applyTextLinkStyles(wrapped, resolveLinkColor(block, textTheme)),
  };
}

export function textBlockHtml(
  block: TextBlock,
  textTheme: BlockRenderProps['textTheme'],
  mergeMode: BlockRenderProps['mergeMode'],
) {
  const normalized = normalizeTextHtml(merge(block.html, mergeMode));
  return textBlockHtmlFromNormalized(block, textTheme, normalized);
}

export function renderTextBlock({
  block,
  textTheme,
  mergeMode,
  editorMode = false,
}: BlockRenderProps & { block: TextBlock }) {
  const normalized = normalizeTextHtml(merge(block.html, mergeMode));
  if (!editorMode && isEmailBuilderRichTextEmpty(normalized)) {
    return null;
  }

  return (
    <TextBlockShell
      block={block}
      textTheme={textTheme}
      dangerouslySetInnerHTML={textBlockHtmlFromNormalized(
        block,
        textTheme,
        normalized,
      )}
    />
  );
}
